import { OrderFile } from 'contracts/OrderFiles';
import * as S from './styles';
import { DownloadButton } from 'components/Shared';

interface Props {
  files: OrderFile[];
}

const OrderFiles = ({ files }: Props) => {
  return (
    <S.List>
      <S.ListHeader>
        <div>Documento</div>
        <div>Download</div>
      </S.ListHeader>
      {files.map((item) => (
        <S.ListItem key={item.id}>
          <S.Column>{item.fileName}</S.Column>
          <S.Column>
            <DownloadButton fileKey={item.fileName}>
              <S.DownloadIcon />
            </DownloadButton>
          </S.Column>
        </S.ListItem>
      ))}
    </S.List>
  );
};

export default OrderFiles;
